import React from 'react';
import { AvButton, AvTooltipProps, ButtonKinds } from '@fabric-ui/components';
import { Like as LikeIcon } from '@fabric-ui/icons';
import { iconSize } from '@fabric-ui/utils';
import { SxProps, Theme } from '@mui/material';

interface LikeProps {
  reversed?: boolean;
  selected?: boolean;
  onClick?: () => void;
  tooltip?: string;
  toolTipProps?: Omit<AvTooltipProps, 'children'>;
  size?: number;
  sx?: SxProps<Theme>;
  disabled?: boolean;
}

const COLOR_MAP = {
  green: {
    outlineColor: 'var(--dataviz-color-sequential-green-scale05)',
    innerFillColor: 'var(--dataviz-color-sequential-green-scale01)',
  },
  red: {
    outlineColor: 'var(--dataviz-color-sequential-red-scale05)',
    innerFillColor: 'var(--dataviz-color-sequential-red-scale01)',
  },
};

const buttonSx: SxProps<Theme> = {
  p: '2px',
  borderRadius: '4px',
  '&:hover': { backgroundColor: 'var(--color-background-base-hover)' },
};

const Like: React.FC<LikeProps> = ({
  reversed = false,
  selected = false,
  onClick,
  tooltip,
  toolTipProps,
  size = 20,
  sx,
  disabled = false,
}) => {
  const label = tooltip ?? (reversed ? 'Bad Response' : 'Good Response');
  const { outlineColor, innerFillColor } = selected ? COLOR_MAP[reversed ? 'red' : 'green'] : {};

  return (
    <AvButton
      kind={ButtonKinds.ICON}
      onClick={onClick}
      aria-label={label}
      disabled={disabled}
      size="small"
      tooltip={label}
      toolTipProps={toolTipProps}
      sx={{
        ...buttonSx,
        ...(selected && { '& path:first-of-type': { fill: innerFillColor } }),
        ...sx,
      }}>
      <LikeIcon
        style={{
          ...iconSize(size),
          ...(reversed && { transform: 'rotate(180deg)' }),
          ...(outlineColor && { color: outlineColor }),
        }}
      />
    </AvButton>
  );
};

export default Like;
